//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../no/NXObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"HoleShape",1,0],[1,"PunchDiameter",0,"Expression",0],[1,"PunchLength",0,"Expression",0],[1,"PunchRadius",0,"Expression",0],[1,"PunchWidth",0,"Expression",0],[0,"ReferenceVector",1,"ILocation",0],[0,"SizingMethod",1,0]],[[["objects"],"SetPierceObjects",{},1,0],[["num_objects"],"GetPierceObjects",{R_:{objects:"IProfile[]"}},0,0]],[]];
SPLM.Die.PierceItemBuilder = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.PierceItemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.PierceItemBuilder.SizingMethodOption = Object.freeze({
    "Auto" : "Auto", "Manual" : "Manual"});

SPLM.Die.PierceItemBuilder.HoleShapeType = Object.freeze({
    "Circular" : "Circular", "Oblong" : "Oblong", "Square" : "Square", "Rectangular" : "Rectangular", "RoundedRectangular" : "RoundedRectangular", "ChordRectangular" : "ChordRectangular", "Hexagonal" : "Hexagonal", "Other" : "Other"});

export default SPLM;